// @ts-nocheck


import React, { useState, useCallback } from 'react';

import { goBack } from '../../../lib/helpers';
import { budgetLineItemApi } from '../../../lib/api';


import CommonCardPage from '../../../components/hoc/common/handbook/CardPage';
import InnerForm from './components/InnerForm';





const entryPointPath = '/admin/expense-direction/budget-line-item/';

export default (props) => {
  const [data, setData] = useState({
    id: props.id
  });

  // const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await budgetLineItemApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload) => {
    let id = payload.id;
    if (id) {
      await budgetLineItemApi.update(payload);
    } else {
      let data = await budgetLineItemApi.add(payload);
      id = data.id;
    }
    await goBack(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload) => {
    if (data.id) {
      await goBack(`${entryPointPath}${data.id}`);
    } else await goBack(`${entryPointPath}`);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs: [
        { to: '/', name: 'Главная' },
        {
          to: '/admin/expense-direction/budget-line-item',
          name: 'Список статей бюджетной формы'
        },
        { name: 'Статья бюджетной формы' }],

        mainHeader: 'Статья бюджетной формы'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}>

      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>);

};
